var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],staticClass:"d-flex h-100 w-100 justify-content-center align-items-center full-screen"})
}
var staticRenderFns = []

export { render, staticRenderFns }